<template>
    <Button
        @click="isOpen = true"
        iconName="plus"
        color="dark"
    >
        Create
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
        width="wide"
    >
        <template #title> Create </template>
        <template #content>
            <ApiForm
                :url="urlFactory.makeAutomationStoreUrl()"
                method="POST"
                ref="apiFormRef"
            >
                <CreateAutomationForm
                    :errors="apiFormRef?.response?.getErrors() ?? null"
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
            >
                Cancel
            </Button>
            <Button
                @click="submit"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Automation from '@/App/Automation/Entity/Automation'
    import CreateAutomationForm from '@/App/Automation/Component/CreateAutomationForm.vue'

    const isOpen = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.finally(() => {
            isOpen.value = false
        })
    }
    const urlFactory = new UrlFactory()
</script>
